// extracted by mini-css-extract-plugin
export default {"loginbg":"VerificationAccount_loginbg__5uoA0","description":"VerificationAccount_description__7bZVX","resendLinkButton":"VerificationAccount_resendLinkButton__mGJKF"};